import classNames from 'classnames';
import { Typography } from 'seagull';
import styles from "./ServicesSection.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ServicesSection(props) {
  const {
    title,
    subtitle,
    hasOptionalServices,
    category,
    children,
    'data-testid': testid
  } = props;
  return /*#__PURE__*/_jsxs("li", {
    className: classNames(styles.section, styles[category]),
    "data-testid": testid,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.sectionHeader,
      children: [hasOptionalServices && category !== 'variable' && /*#__PURE__*/_jsx(Typography, {
        variant: "paragraph3",
        skin: "secondary",
        "data-testid": testid && testid + '-has-optional',
        children: "Starts at"
      }), /*#__PURE__*/_jsx(Typography, {
        "data-testid": testid && testid + '-title',
        children: title
      }), subtitle && /*#__PURE__*/_jsx(Typography, {
        variant: "paragraph3",
        weight: "normal",
        "data-testid": testid && testid + '-subtitle',
        children: subtitle
      })]
    }), /*#__PURE__*/_jsx("ul", {
      children: children
    })]
  });
}